import { Price, PriceList } from 'src/types';
import { filterOffersGeneric } from './filtering-generic';
import { IFilter } from './types';

export const getAllOffersAsArray = (priceList?: PriceList | null): Price[] => {
  const offers = priceList?.nodes?.filter(x => x) as Price[] | null | undefined;
  return offers ?? [];
};

export const filterOffers = (
  filters: IFilter[],
  priceList?: PriceList | null
): Price[] => {
  let filteredOffers = getAllOffersAsArray(priceList);
  filters.forEach(filter => {
    filteredOffers = filterOffersGeneric(filteredOffers, filter);
  });
  return filteredOffers;
};
